export default __webpack_public_path__ + "static/media/btn-alle-lieder.4e744bf1.png";